import styled from "@xstyled/styled-components";
import { useMemo } from "react";

import { useJobEditFormikContext } from "../../useHandlers";

import { Location } from "@hire/schema";
import { pxToRem } from "@otta/design-tokens";
import { FieldWrapper, SelectField } from "@otta/design";
import {
  locationToLocationOption,
  REMOTE_LOCATIONS,
} from "@hire/util/locations";

const NarrowSelect = styled(SelectField)`
  max-width: ${pxToRem(400)};
`;

export const RemoteField = () => {
  const form = useJobEditFormikContext();

  const options = useMemo(() => {
    return REMOTE_LOCATIONS.map(locationToLocationOption)
      .filter(
        (option): option is { label: string; value: Location } => !!option
      )
      .map(option => {
        return {
          value: option.value,
          label: option.label.replace("(", "").replace(")", ""),
        };
      });
  }, []);

  const value = useMemo(
    () =>
      options.filter(
        option =>
          option && form.values.remoteLocationPreferences.includes(option.value)
      ),
    [form.values.remoteLocationPreferences, options]
  );

  return (
    <FieldWrapper
      showOptionalTag={false}
      label="Remote locations"
      advice="Places remote candidates can work from, supported by our matching algorithm."
      fieldError={
        form.touched.remoteLocationPreferences
          ? form.errors.remoteLocationPreferences
          : undefined
      }
    >
      {({ field }) => (
        <NarrowSelect
          inputId={field.id}
          placeholder="Type or select locations&hellip;"
          options={options}
          value={value}
          onChange={selected => {
            const newValue = selected
              ? Array.isArray(selected)
                ? selected.map(v => v.value)
                : [selected]
              : [];

            form.setFieldValue("remoteLocationPreferences", newValue);
          }}
          onBlur={() => {
            form.setFieldTouched(
              "remoteLocationPreferences",
              true,
              !!form.validateOnBlur
            );
          }}
          aria-describedby={field["aria-describedby"]}
          aria-invalid={field["aria-invalid"]}
          hideSelectedOptions={false}
          closeMenuOnSelect={false}
          isMulti
        />
      )}
    </FieldWrapper>
  );
};
